import { getFormNodeByName } from 'common/entities/formNode/selectors';
import { NODE_NAME_SOCIAL_RSVP } from 'common/entities/formNode/nodeNames';

import { createActionUpdateFormNode } from './nodeActions';
import { getFormId } from '../selectors';

export const setSocialRsvpEnabled = (socialNetwork, enabled) => (dispatch, getState) => {
    const state = getState();
    const formId = getFormId(state);
    const socialRsvpNode = getFormNodeByName(state, formId, NODE_NAME_SOCIAL_RSVP);
    const updates = {
        config: {
            ...socialRsvpNode.config,
            [socialNetwork]: {
                ...socialRsvpNode.config[socialNetwork],
                enabled,
            },
        },
    };

    dispatch(createActionUpdateFormNode(socialRsvpNode, updates));
};

export const setPrepopulatedNode = (socialNetworkQuestion, nodeId) => (dispatch, getState) => {
    const state = getState();
    const formId = getFormId(state);
    const socialRsvpNode = getFormNodeByName(state, formId, NODE_NAME_SOCIAL_RSVP);
    const updates = {
        fields: {
            ...socialRsvpNode.fields,
            [socialNetworkQuestion]: {
                ...socialRsvpNode.fields[socialNetworkQuestion],
                prepopulateNodeId: nodeId,
            },
        },
    };

    dispatch(createActionUpdateFormNode(socialRsvpNode, updates));
};
